import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-etapas-beneficio',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './etapas-beneficio.component.html',
  styleUrls: ['./etapas-beneficio.component.scss']
})
export class EtapasBeneficioComponent {
  @Input() etapaSelecionada: number = 1;
  @Output() mudouEtapa = new EventEmitter<number>();

  constructor(private router: Router) {

  }

  etapas: string[] = [
    'Dados Pessoais',
    'Dados Funcionais',
    'Afastamento',
    'Alterações Funcionais',
    'Deduções',
    'Acrescimos',
    'Regras',
    'Composição do Ato',
    'Anexar Documentos',
    'Baixar Requerimento',
    'Abrir Processo'
  ];

  selecionarEtapa(numero: number): void {
    this.etapaSelecionada = numero;
    if(numero==1) {
        this.router.navigateByUrl('/dados-pessoais')
    } else if(numero==2) {
        this.router.navigateByUrl('/dados-funcionais')
    } else if(numero==3) {
        this.router.navigateByUrl('/afastamento')
    } else if(numero==4) {
        this.router.navigateByUrl('/alteracoes-funcionais')
    } else if(numero==5) {
        this.router.navigateByUrl('/deducoes')
    } else if(numero==6) {
        this.router.navigateByUrl('/acrescimos')
    } else if(numero==7) {
        this.router.navigateByUrl('/regras')
    } else if(numero==8) {
        this.router.navigateByUrl('/composicao-ato')
    } else if(numero==9) {
        this.router.navigateByUrl('/anexar-documentos')
    } else if(numero==10) {
        this.router.navigateByUrl('/requerimento-download')
    } else if(numero==11) {
        this.router.navigateByUrl('/abrir-processo')
    }
    this.mudouEtapa.emit(numero);
  }
}
